import React from "react";
import Account, { PasswordRecovery } from "../components/Account";

export default function AccountContainer(props) {
    return (
        <>
            {props.account && <Account />}
            {props.recovery && <PasswordRecovery />}
        </>
    );
}
